import analyticsTracking from "./analytics-tracking";

class LeadModalForm {
  modal = undefined;
  constructor(modal, analyticsTracking, wpDeployEnv) {
    this.modal = modal;
    this.analyticsTracking = analyticsTracking;
    this.form = modal.querySelectorAll("form")[0];
    this.submitButton = this.form.querySelectorAll('[type="submit"]')[0];
    this.emailField = this.form.querySelectorAll('[name="Email"]')[0];
    this.emailFieldContainer = this.emailField.parentNode;
    this.wpDeployEnv = wpDeployEnv;
    this.registerEvents();
  }

  registerEvents() {
    if (this.modal) {
      this.analyticsTracking.notifyMotomo("trackForm", this.form);

      this.emailField.addEventListener(
        "change",
        function () {
          this.hideEmailError();
        }.bind(this)
      );

      this.form.addEventListener(
        "submit",
        function (event) {
          event.preventDefault();

          if (this.submitButton) {
            this.submitButton.disabled = true;
          }

          this.submit(event);

          return false;
        }.bind(this)
      );
    }
  }

  submit(event) {
    var data = Object.fromEntries(new FormData(event.target));
    const instance = this;

    const leadApiData = {
      ...data,
      ID: 0,
      SubscribeEmail: "1",
      Completed: 1,
      RequestSource: "BLOG",
      RequestType: "SFO"
    };

    this.hideEmailError();
    const url =
      this.wpDeployEnv === "production"
        ? "https://api2.digital.silversea.com/leadApiSubmission"
        : "https://dev-api2.digital.silversea.com/leadApiSubmission";

    fetch(url, {
      method: "POST",
      body: JSON.stringify(leadApiData),
      headers: {
        "Content-type": "application/json; charset=UTF-8"
      }
    })
      .then(function (response) {
        if (response.ok || response.status == 422) {
          return response.json().then(function (data) {
            const isEmailError = (data || {}).field == "Email";
            if (response.status == 422 && isEmailError)
              instance.showEmailError();

            if (response.status == 201) instance.formSubmitted(data);

            instance.enableForm();
          });
        }

        return Promise.reject(response);
      })
      .catch(function (error) {
        console.warn(error);

        instance.enableForm();
      });
  }

  formSubmitted(res) {
    this.trackFormSubmitted(res);
    this.showThankYouMessage();
  }

  getEmailFieldErrorContainer() {
    return this.emailFieldContainer.querySelectorAll("#email-field-error")[0];
  }

  showEmailError() {
    const fieldError = this.getEmailFieldErrorContainer();

    if (!fieldError)
      this.emailFieldContainer.insertAdjacentHTML(
        "beforeend",
        `<small id="email-field-error" class="form-text text-danger"><strong>Incorrect email address</strong></small>`
      );

    console.debug("email error");
  }

  trackFormSubmitted(event) {
    this.analyticsTracking.notifyMotomo("trackFormConversion", this.form);
    this.analyticsTracking.dispatchTrackingEvent(
      "web-request-submitted",
      event
    );
  }

  hideEmailError() {
    const fieldError = this.getEmailFieldErrorContainer();
    if (fieldError) fieldError.parentNode.removeChild(fieldError);
  }

  enableForm() {
    if (this.submitButton) {
      this.submitButton.disabled = false;
    }
  }

  showThankYouMessage() {
    var success = document.createElement("p");
    success.className = "wplf-success";
    success.innerHTML = `<strong>Thank you for subscribing.</strong><br />Delivered to your inbox, our stories will take you closer to the authentic beauty of the world.`;

    this.form.parentNode.insertBefore(success, this.form.nextSibling);
    this.form.parentNode.removeChild(this.form);
  }
}
export default LeadModalForm;
